import React, { useContext } from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import {
  SITE_HEADER_LOGGED_IN_REAL_ESTATE_ID,
  SITE_HEADER_ANON_REAL_ESTATE_ID,
} from '../constants';

import sharedVars from '@wix/da-ds/src/styles/variables.scss';

export interface Props {
  className?: string;
}

const SiteHeaderPlacement: React.FC<Props> = ({ className }) => {
  const { isLoggedIn } = useContext(SessionContext);

  // User
  if (isLoggedIn) {
    return (
      <BannerAdUnit
        width="100px"
        height={sharedVars['site-header-height']}
        realEstateId={SITE_HEADER_LOGGED_IN_REAL_ESTATE_ID}
        className={className}
      />
    );
  }

  // Anon
  return (
    <BannerAdUnit
      width="100px"
      height={sharedVars['site-header-height']}
      realEstateId={SITE_HEADER_ANON_REAL_ESTATE_ID}
      className={className}
    />
  );
};
SiteHeaderPlacement.displayName = 'SiteHeaderPlacement';

export default SiteHeaderPlacement;
